let isRedirectingToMaintenance = false;

/**
 * メンテナンス状態のAPIレスポンスで最低限保証される内容
 */
type MaintenanceResponse = {
  code: number;
};

/**
 * レスポンスがメンテモードかどうか判別する
 * @param data - データ
 * @returns レスポンスがメンテモードレスポンスか
 */
const isMaintenanceResponse = (data: unknown): data is MaintenanceResponse => {
  return typeof data === 'object' && data !== null && 'code' in data && data.code === 9999;
};

/**
 * レスポンスがメンテモードだった時にメンテモードの画面に遷移する
 * @param data - レスポンス内データ
 */
export const redirectIfInMaintenanceMode = (data: unknown): boolean => {
  if (!isMaintenanceResponse(data)) {
    return false;
  }

  if (!isRedirectingToMaintenance) {
    isRedirectingToMaintenance = true;
    window.location.replace('/maintenance.html');
  }

  return true;
};
